import { render, staticRenderFns } from "./Bayonot.vue?vue&type=template&id=8c0833d2"
import script from "./Bayonot.vue?vue&type=script&lang=js"
export * from "./Bayonot.vue?vue&type=script&lang=js"
import style0 from "./Bayonot.vue?vue&type=style&index=0&id=8c0833d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports